import React, { useContext } from 'react';
import Head from '../Head';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { FlagContext } from '@wix/da-react-context/pkg/flags/FlagContext';
import Flag from '@wix/da-react-context/pkg/flags/Flag/Flag';
import { useSelector } from 'react-redux';
import { getEnv } from '../Environment/redux/selectors';
const Document = ({ children })=>{
    var _session_device;
    const session = useContext(SessionContext);
    const flags = useContext(FlagContext);
    const env = useSelector(getEnv);
    return /*#__PURE__*/ React.createElement("html", {
        lang: "en",
        "data-appinfo": env.appInfo
    }, /*#__PURE__*/ React.createElement(Head, null), /*#__PURE__*/ React.createElement("body", {
        className: getGlobalClassnamesForContext({
            flags,
            isLoggedIn: session.isLoggedIn,
            isMobile: (_session_device = session.device) === null || _session_device === void 0 ? void 0 : _session_device.isMobile,
            theme: session.theme,
            themeSkin: session.themeSkin
        })
    }, /*#__PURE__*/ React.createElement(Flag, {
        condition: "strictmode",
        render: ()=>/*#__PURE__*/ React.createElement(React.StrictMode, null, children),
        fallbackRender: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, children)
    })));
};
Document.displayName = 'Document';
export default Document;
